import { FC, useEffect } from "react";
import {
  Box,
  Grid,
  Modal,
  Typography,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Button,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";

type Props = {
  open: boolean;
  onClose: () => void;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isDownloading: boolean;
  setFileName: (fileName: string) => void;
  fileName: string;
};

export const UploadModalEmployee: FC<Props> = ({
  open,
  onClose,
  handleFileChange,
  isDownloading,
  setFileName,
  fileName,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    setFileName(event.target.value);
  };

  const filesNamesMap = new Map<string, string>([
    ["Psychologisches Gutachten hochladen", "psychologisches-gutachten"],
    ["Datei Hochladen", "datei-hochladen"],
    ["MMK-Befund", "mmk-befund"],
  ]);

  const closeModal = () => {
    onClose();
  };
  useEffect(() => {
    if (isDownloading) {
      closeModal();
    }
  });

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "30%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        {isDownloading && <div>Downloading...</div>}
        <Typography id="modal-modal-title" variant="h6">
          Neue Datei hochladen
        </Typography>
        <Typography
          id="modal-modal-description"
          fontWeight={700}
          sx={{ mt: 2 }}
        >
          Bitte wählen Sie die Art der Datei und laden Sie sie hoch.
        </Typography>

        <Box component="form" noValidate sx={{ mt: 3 }}>
          <Grid
            container
            flexDirection="column"
            spacing={3}
            alignItems="center"
          >
            <Grid item xs={12} width="100%">
              <FormControl fullWidth variant="standard">
                <InputLabel id="fileType">Wählen Sie eine Datei aus</InputLabel>
                <Select
                  value={fileName}
                  labelId="fileType"
                  id="fileType"
                  label="fileType"
                  onChange={handleChange}
                >
                  {Array.from(filesNamesMap, ([label, value]) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              width="100%"
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                size="medium"
                variant="outlined"
                component="label"
                disabled={fileName === ""}
                sx={{
                  border: "1px solid #000",
                  borderRadius: "1.2em",
                  width: "90%",
                }}
              >
                Datei Hochladen
                <FileUploadIcon sx={{ marginLeft: "0.25em" }} />
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    if (e.target.files) {
                      handleFileChange(e);
                    }
                  }}
                />
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};
